function d(e, i) {
  for (var n = -1, r = e == null ? 0 : e.length, u = 0, t = []; ++n < r; ) {
    var l = e[n];
    i(l, n, e) && (t[u++] = l);
  }
  return t;
}
export {
  d as default
};
